import type React from "react";

/** Debounce delay for search inputs (ms) */
export const SEARCH_DEBOUNCE_MS = 300;

/** Canonical path for the admin users page — used for revalidation after mutations and post-action navigation */
export const USERS_PATH = "/admin/users";

/** Minimum characters before search fires */
export const MIN_SEARCH_LENGTH = 2;

/** Number of users to fetch per page in the user list */
export const USERS_PAGE_SIZE = 30;

/** Number of items to fetch per page in modal search lists */
export const MODAL_PAGE_SIZE = 20;

/** Maximum number of users that can be bulk-created at once */
export const MAX_BULK_USERS = 100;

/** AG Grid transparent style overrides matching existing codebase pattern */
export const AG_GRID_STYLE = {
  "--ag-background-color": "transparent",
  "--ag-header-background-color": "transparent",
  "--ag-odd-row-background-color": "transparent",
  "--ag-row-hover-color": "#f3f4f6",
  "--ag-border-color": "transparent",
  "--ag-header-column-separator-color": "transparent",
  "--ag-row-border-color": "#e5e7eb",
  "--ag-header-column-resize-handle-color": "transparent",
  "--ag-cell-horizontal-border": "none",
} as React.CSSProperties;

/** Shared default column definition for all AG Grid tables in this feature */
export const DEFAULT_COL_DEF = {
  sortable: true,
  resizable: true,
  cellStyle: { display: "flex", alignItems: "center" },
};

/**
 * Calculates the AG Grid container height based on row count.
 * Caps at 350px to keep tables within a reasonable viewport.
 * @param rowCount - Number of data rows
 * @returns Height in pixels
 */
export function getTableHeight(rowCount: number): number {
  return Math.min(rowCount * 44 + 48, 350);
}
